import { apiClient } from "../client/ApiClient";
import { CommercialNonWorkingDay } from "../types/CommercialNonWorkingDay";

const getCommercialNonWorkingDays = async (): Promise<
  CommercialNonWorkingDay[]
> => {
  return await apiClient
    .get<CommercialNonWorkingDay[]>("/calendar/commercial-non-working-days")
    .then((response) => response.data);
};

export default getCommercialNonWorkingDays;
